import script from "./IngressCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./IngressCards.vue?vue&type=script&setup=true&lang=ts"

import "./IngressCards.vue?vue&type=style&index=0&id=7ed9b48d&scoped=true&lang=scss"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed9b48d"]])

export default __exports__